import { PRESENCE_LEASE_EXPIRED } from "../model/presenceConstants";

/** userId -> timeout id */
const timers = new Map();

export function clearPresenceLeaseTimer(userId) {
  const key = String(userId);
  const handle = timers.get(key);
  if (handle != null) {
    clearTimeout(handle);
    timers.delete(key);
  }
}

export function clearAllPresenceLeaseTimers() {
  for (const handle of timers.values()) {
    clearTimeout(handle);
  }
  timers.clear();
}

/**
 * Schedule a one-shot offline transition when authoritative lease expires.
 * Not a polling loop — one timer per watched user, replaced on fresher updates.
 */
export function syncPresenceLeaseTimer(presence, dispatch) {
  if (!presence || presence.userId == null) return;
  const userId = presence.userId;
  clearPresenceLeaseTimer(userId);

  if (!presence.online || !presence.leaseExpiresAt) {
    return;
  }

  const expiresMs = Date.parse(presence.leaseExpiresAt);
  if (Number.isNaN(expiresMs)) return;

  const delay = Math.max(0, expiresMs - Date.now());
  const leaseExpiresAt = presence.leaseExpiresAt;
  const handle = setTimeout(() => {
    timers.delete(String(userId));
    dispatch({
      type: PRESENCE_LEASE_EXPIRED,
      payload: { userId, leaseExpiresAt },
    });
  }, delay);
  timers.set(String(userId), handle);
}

export function getPresenceLeaseTimerCountForTests() {
  return timers.size;
}
